export const InsightDurationMonthly = 'Monthly';
export const InsightDurationWeekly = 'Weekly';
export const InsightDurationDaily = 'Daily';
export const InsightDurationYearly = 'Yearly';